
















































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import Vue from 'vue';

import { TradingVue, DataCube } from 'trading-vue-js';
let inst, token, id;

import { core } from '../tradeCore';
import { demo } from '../tradeDemo';

import { createLiveFeed, configuredTickers } from '@/tiingoApi';
const inMult = 5;
const outMult = 10;

function getNonRefObj(obj) {
    const _ = JSON.stringify(obj);
    return JSON.parse(_);
}
// Safe read of a JSON value from localStorage. Returns null when the key is
// absent, holds the literal string "null"/"undefined", or is unparseable, so
// callers never get a surprise null out of JSON.parse(String(getItem(...))).
function readStored(key) {
    try {
        const raw = window.localStorage.getItem(key);
        if (raw == null || raw === 'null' || raw === 'undefined') {
            return null;
        }
        return JSON.parse(raw);
    } catch (err) {
        return null;
    }
}
function dataTemplate(tf: number) {
    return JSON.stringify({
        chart: {
            type: window.localStorage.getItem('chartType') || 'Candles',
            indexBased: false,
            data: [],
            tf: tf * 1000,
        },
        onchart: [
            {
                name: 'Candles/Bars',
                type: 'Swap',
                data: [],
                settings: {
                    showLabel: false,
                    track: true,
                    pending: false,
                    pending_type: '',
                },
            },
            {
                name: 'Trades',
                type: 'PerfectTrades',
                data: [],
                settings: {
                    'z-index': 5,
                    inMult: inMult,
                    outMult: outMult,
                    night:
                        window.localStorage.getItem('nm') != null
                            ? window.localStorage.getItem('nm') == 'true'
                                ? true
                                : false
                            : true,
                    mult: 1,
                },
            },
        ],
    });
}

// Tiingo's free tier allows 50 REST requests/hour. The old loop refetched every
// visible chart once a minute (~240/hour with four charts), which drained the
// quota on its own. The WebSocket feed carries live updates now, so this
// periodic REST refresh is only a backstop against drift.
const REFRESH_TICKS = Number(process.env.VUE_APP_TIINGO_REFRESH_SECONDS || 900);

const timeFrames = [
    { text: 'M1', value: 60 },
    { text: 'M2', value: 120 },
    { text: 'M3', value: 180 },
    { text: 'M5', value: 300 },
    { text: 'M10', value: 600 },
    { text: 'M15', value: 900 },
    { text: 'M30', value: 1800 },
    { text: 'H1', value: 3600 },
    //{ text: 'H2', value: 7200 },
    //{ text: 'H4', value: 14400 },
    //{ text: 'H8', value: 28800 },
    //{ text: 'D1', value: 86400 },
];
function mkTfs() {
    let res = {};
    timeFrames.forEach((el) => {
        res[el.value] = el.text;
    });
    return res;
}
function mkIds() {
    let res = {};
    for (let i = 0; i < timeFrames.length; i++) {
        res[`${timeFrames[i].value}`] = i;
    }
    return res;
}
function mkData() {
    let res = [] as any[];
    for (let i = 0; i < timeFrames.length; i++) {
        res.push(
            new DataCube(JSON.parse(dataTemplate(timeFrames[i].value)), {
                auto_scroll: false,
                scripts: true,
                script_depth: 0,
            })
        );
    }
    return res;
}

import {
    ALMA,
    Area51,
    ATR,
    ATRp,
    BB,
    BBW,
    CCI,
    CMO,
    COG,
    DHistogram,
    DMI,
    EMA,
    Histogram,
    HMA,
    Ichi,
    Ichimoku,
    KC,
    KCW,
    LongShortTrades,
    MACD,
    Markers,
    MFI,
    MOM,
    PerfectTrades,
    PlotCross,
    Ribbon,
    ROC,
    RSI,
    SAR,
    SMA,
    Stoch,
    SWMA,
    TradesPlus,
    TSI,
    VWMA,
    WilliamsR,
    XOhlcBars,
} from '@/Scripts/Indicators.js';
import Fibo from '@/Scripts/Fibo.js';
import LineTool from '@/Scripts/LineTool.js';
import Swap from '@/Scripts/Swap.js';
import Pline from '@/Scripts/Pline.js';
import iOvl from '@/components/indOvl.vue';
import { nextTick } from 'vue/types/umd';
import vuetify from 'vuetify/lib/framework';

// The Tiingo feed owns the socket and its reconnect backoff (src/tiingoApi.js).
let liveFeed: any;
function parseSettings(ind_set: any, side: string) {
    let set = {};
    for (const key in ind_set.settings) {
        if (Object.prototype.hasOwnProperty.call(ind_set.settings, key)) {
            if (key != 'loading' && key != 'tf') {
                set[key] = ind_set.settings[key];
            }
        }
    }
    return { set: { name: ind_set.name, loading: false, data: [], type: ind_set.type, settings: set }, side: side };
}

export default Vue.extend({
    name: 'tradeview',
    props: {
        night: {
            type: Boolean,
            default: () => {
                return true;
            },
            required: false,
        },
        demo: {
            type: Boolean,
            default: () => {
                return true;
            },
            required: false,
        },
        tradewins: {
            type: Boolean,
            default: () => {
                return false;
            },
            required: false,
        },
    },
    watch: {
        pending(v) {
            if (!v) {
                this.pendingPosType = '';
                this.pendingPos = {
                    symbole: '',
                    symboleName: '',
                    value: 0,
                    type: '',
                    price: 0,
                    duration: 60,
                };
            }
        },
        pendingPosType(v) {
            if (v == '') {
                this.datas[this.activeChart[this.activeChartId].intId][this.activeChart[this.activeChartId].tfid].merge(
                    'onchart.Swap.settings',
                    { showLabel: false }
                );
            } else {
                this.datas[this.activeChart[this.activeChartId].intId][this.activeChart[this.activeChartId].tfid].merge(
                    'onchart.Swap.settings',
                    { showLabel: true, type: v }
                );
            }
        },
        pendingOverlay(v) {
            this.datas[this.activeChart[this.activeChartId].intId][this.activeChart[this.activeChartId].tfid].merge(
                'onchart.Swap.settings',
                { track: !v }
            );
        },
        deltaTime(v) {
            if (v > 10000) {
                if (!this.stopWatch) {
                    console.log('connexion lost');
                    this.reinitConnexion();
                    this.snackbar = true;
                }
            } else {
                this.snackbar = false;
            }
        },
        maxViewCount(v) {
            if (this.viewCount > v) {
                this.viewCount = v;
            }
        },
        viewCount(v) {
            this.storeAll();
        },
        activecolor(v) {
            window.localStorage.setItem('linecolor', String(v));
        },
        activewidth(v) {
            window.localStorage.setItem('linewidth', String(v));
        },
        activeChartId(v, p) {
            this.tools = false;
            if (this.pending && this.pendingPosType != '') {
                this.datas[this.activeChart[v].intId][this.activeChart[v].tfid].merge('onchart.Swap.settings', {
                    showLabel: true,
                    type: this.pendingPosType,
                });
            } else {
                this.datas[this.activeChart[v].intId][this.activeChart[v].tfid].merge('onchart.Swap.settings', {
                    showLabel: false,
                });
            }
            this.datas[this.activeChart[p].intId][this.activeChart[p].tfid].merge('onchart.Swap.settings', {
                showLabel: false,
            });
        },
        night(v) {
            this.datas[this.activeChart[this.activeChartId].intId][this.activeChart[this.activeChartId].tfid].merge(
                'onchart.Trades.settings',
                { night: v }
            );
        },
    },

    beforeMount() {
        inst = this;
        token = window.localStorage.getItem('token');
        id = window.localStorage.getItem('id');
        if (token && id && token != 'undefined') {
            console.log('#####', token, id);
            this.$emit('loggedin');
        } else {
            window.location.href = '/#/login';
        }
        const allowTrading = window.localStorage.getItem('allow_trading');
        if (allowTrading) {
            if (allowTrading == 'disallow') {
                this.allowtrading = false;
            }
        }

        //window.localStorage.setItem('interval_ms', `${this.tf * 1000}`);
        //this.width = window.innerWidth - (this.$vuetify.breakpoint.smAndDown ? 0 : 250);
        const on = window.localStorage.getItem('on');
        // Key is versioned: a v1 list holds Deriv symbols that Tiingo rejects.
        // A returning user from the pre-Tiingo build has `on` set but no v2 list,
        // so JSON.parse('null') used to leave activeSymbols null and every
        // activeSymbols.length read below (and in mounted/onResize/render) threw.
        // Only restore a persisted session when it carries a usable symbol list;
        // otherwise keep the component's BTCUSD defaults.
        const savedSymbols = readStored('activeSymbols_v2');
        if (on != null && Array.isArray(savedSymbols) && savedSymbols.length > 0) {
            this.activeSymbols = savedSymbols;
            // Rebuild the id map from the restored list so a stale or missing
            // `ids` entry can't desync lookups (activeSymbols[ids[sym]] throws).
            this.ids = {};
            this.activeSymbols.forEach((s, i) => {
                this.ids[s.id] = i;
            });
            this.prices = readStored('prices') || {};
            this.maxViewCount = this.activeSymbols.length > 4 ? 4 : this.activeSymbols.length;
            this.maxViewCount = this.maxViewCount > 2 && (this.sm || this.height < 500) ? 2 : this.maxViewCount;
            const activeChart = readStored('activeCharts');
            if (activeChart != null) {
                this.activeChart = activeChart;
            }
            let viewCount = readStored('viewCounts') || 1;
            viewCount = viewCount <= this.maxViewCount ? viewCount : this.maxViewCount;
            this.changeViewCount(viewCount);
            this.datas = [];
            for (let i = 0; i < this.activeSymbols.length; i++) {
                this.datas.push(mkData());
            }
        }
    },
    mounted() {
        this.sm = window.innerWidth < 950 ? true : false;
        this.height = window.innerHeight - (this.sm ? 142 : 150);
        this.width = window.innerWidth - 8 - (this.sm || this.height < 500 ? 4 : 250);
        this.landscape = window.innerWidth > window.innerHeight;
        this.stopWatch = false;
        window.addEventListener('resize', this.onResize);
        window.addEventListener('blur', this.onBlur);
        window.addEventListener('focus', this.onFocus);
        this.watchUpdate(0);
        setInterval(() => {
            this.ping(this.activeChartId);
        }, 3000);
        this.counter();
    },
    beforeDestroy() {
        this.closing = true;
        this.stopWatch = true;
        this.symbols = [];
        window.removeEventListener('resize', this.onResize);
        window.removeEventListener('blur', this.onBlur);
        window.removeEventListener('focus', this.onFocus);
        if (liveFeed != undefined) {
            liveFeed.stop();
        }
    },
    computed: {
        colors: () => {
            return inst.night
                ? {
                      colorBack: '#1E1E1E',
                      colorTitle: '#1E88E5',
                      colorCU: window.localStorage.getItem('cud') || '#1E88E5',
                      colorCD: window.localStorage.getItem('cdd') || '#C62828',
                  }
                : {
                      colorBack: '#fff',
                      colorGrid: '#eee',
                      colorText: '#333',
                      colorTitle: '#007BFF',
                      colorCU: window.localStorage.getItem('cul') || '#03A9F4',
                      colorCD: window.localStorage.getItem('cdl') || '#FF3333',
                  };
        },
        closeData: () => {
            let result = '';
            if (inst.lastPos == 'sell') {
                if (inst.currentPrice < inst.lastPosPrice) {
                    result = `-${inst.lastPosValue} €`; //win
                } else {
                    result = `-${((2 * inst.lastPosValue) / 3).toFixed(2)} €`;
                }
            } else if (inst.lastPos == 'buy') {
                if (inst.currentPrice > inst.lastPosPrice) {
                    result = `-${inst.lastPosValue} €`;
                } else {
                    result = `-${((2 * inst.lastPosValue) / 3).toFixed(2)} €`;
                }
            } else if (inst.lastPos == 'in') {
                if (
                    inst.lastPosPrice + inst.lastPosSpread * inMult > inst.currentPrice &&
                    inst.lastPosPrice - inst.lastPosSpread * inMult < inst.currentPrice
                ) {
                    result = `-${inst.lastPosValue} €`;
                } else {
                    result = `-${((2 * inst.lastPosValue) / 3).toFixed(2)} €`;
                }
            } else if (inst.lastPos == 'out') {
                if (
                    !(
                        inst.lastPosPrice + inst.lastPosSpread * outMult > inst.currentPrice &&
                        inst.lastPosPrice - inst.lastPosSpread * outMult < inst.currentPrice
                    )
                ) {
                    result = `-${inst.lastPosValue} €`;
                } else {
                    result = `-${((2 * inst.lastPosValue) / 3).toFixed(2)} €`;
                }
            }
            return result;
        },
    },

    data: () => ({
        apiInterface: {
            demo: demo.controller,
            core: core.controller,
        },
        allowtrading: true,
        snackbar: false,
        listovl: false,
        startTime: Date.now(),
        blurTime: Date.now(),
        focused: true,
        keys: [0, 0, 0, 0] as any[],
        buttons: ['display'],
        sm: window.innerWidth < 950 ? true : false,
        smTools: false,
        tools: false,
        height: window.innerHeight - (window.innerWidth < 950 ? 142 : 150),
        width:
            window.innerWidth -
            8 -
            (window.innerWidth < 950 || window.innerHeight - (window.innerWidth < 950 ? 142 : 150) < 500 ? 4 : 250),
        landscape: window.innerWidth > window.innerHeight,
        closing: false,
        activecolor: window.localStorage.getItem('linecolor') || '#42b28a',
        activewidth: window.localStorage.getItem('linewidth') || 0.9,
        widthValues: [0.5, 1, 1.5, 2, 2.5, 3, 4, 6],
        indOvl: false,
        ovlK: 0,
        autoScroll: true,
        symboleListes: false,
        tab: 'transactions',
        items: [
            { title: 'Upload to AI', icon: 'mdi-view-dashboard' },
            { title: 'Photos', icon: 'mdi-image' },
            { title: 'About', icon: 'mdi-help-box' },
        ],
        t: 0,
        solde: 0,
        value: 1,
        tradeType: 'up-down',
        tradeTypes: [
            { value: 'up-down', text: 'Buy - Sell' },
            { value: 'range', text: 'Range' },
        ],
        duration: 60000,
        pending: false,
        pendingPosType: '',
        pendingOverlay: false,
        pendingPos: {
            symbole: '',
            symboleName: '',
            value: 0,
            type: '',
            price: 0,
            duration: 60,
        },
        marketClosed: false,
        durations: [
            { text: '1mn', value: 60000 },
            { text: '2mn', value: 120000 },
            { text: '5mn', value: 300000 },
            { text: '10mn', value: 600000 },
            { text: '15mn', value: 900000 },
            { text: '30mn', value: 1800000 },
            { text: '1h', value: 3600000 },
            { text: '2h', value: 7200000 },
            { text: '4h', value: 14400000 },
            { text: '8h', value: 28800000 },
        ],
        tfs: timeFrames,
        tfsValues: mkTfs(),
        tfids: mkIds(),
        invRules: [(value: any) => !!value || 'Requise.', (value: any) => value > 0.2 || 'Min. 0,2 €'],
        currentPrice: 0,
        histories: [] as any[],
        lastPos: 'query',
        lastPosValue: 0,
        lastPosPrice: 0,
        lastPosSpread: 0,
        lastPosTS: 0,
        lastPosDuration: 0,
        timer: 0,
        tkey: 0,
        keyid: 1,
        ids: { btcusd: 0 } as any, ///////
        symbolsNames: {} as any,
        prices: {} as any, //////
        winLosses: {} as any,
        poses: {} as any, //////
        symbols: [] as any[], //////////
        activeSymbols: [{ text: 'BTCUSD', id: 'btcusd', on: true }] as any[], //////
        viewCount: 1,
        maxViewCount: 1,
        activeChartId: 0,
        activeChart: [
            {
                tf: 60,
                tfid: 0,
                intId: 0,
                symbol: 'btcusd',
                symbolName: 'BTCUSD',
                timer: 0,
                lastUpdate: 0,
                updated: false,
            },
            {
                tf: 60,
                tfid: 0,
                intId: 0,
                symbol: 'btcusd',
                symbolName: 'BTCUSD',
                timer: 0,
                lastUpdate: 0,
                updated: false,
            },
            {
                tf: 60,
                tfid: 0,
                intId: 0,
                symbol: 'btcusd',
                symbolName: 'BTCUSD',
                timer: 0,
                lastUpdate: 0,
                updated: false,
            },
            {
                tf: 60,
                tfid: 0,
                intId: 0,
                symbol: 'btcusd',
                symbolName: 'BTCUSD',
                timer: 0,
                lastUpdate: 0,
                updated: false,
            },
        ],
        id: 'btcusd',
        // Deriv's 1-second synthetic symbols have no Tiingo equivalent.
        subMins: [] as string[],
        //tf: 60,
        ltf: 60,
        delta: 0,
        range: [0, 0],
        reset: false,
        stopWatch: false,
        lastUpdate: 0,
        now: Date.now(),
        deltaTime: Date.now(),
        lastRequest: 0,
        canvas: [] as any,
        ckey: 0,
        addData: false,
        dataRetrieved: false,
        datas: [mkData()],
        overlays: [
            ALMA,
            Area51,
            ATR,
            ATRp,
            BB,
            BBW,
            CCI,
            CMO,
            COG,
            DHistogram,
            DMI,
            EMA,
            Histogram,
            HMA,
            Ichi,
            Ichimoku,
            KC,
            KCW,
            LongShortTrades,
            MACD,
            Markers,
            MFI,
            MOM,
            PerfectTrades,
            PlotCross,
            Ribbon,
            ROC,
            RSI,
            SAR,
            SMA,
            Stoch,
            SWMA,
            TradesPlus,
            TSI,
            VWMA,
            WilliamsR,
            XOhlcBars,
            Pline,
            Fibo,
            LineTool,
            Swap,
        ],
        bid: [] as any,
        ask: [] as any,
        copytrade: {},
        notifyError: false,
        notificationText: ``,
        notificationTitle: '',
        headers: [
            {
                text: 'Time',
                align: 'start',
                sortable: true,
                value: 'timestamp',
            },
            {
                text: 'Trader',
                sortable: true,
                value: 'uid',
            },
            { text: 'Symbol', value: 'symbol' },
            { text: 'Position', value: 'type' },
            { text: `Open Price`, value: 'priceIn' },
            { text: `Close Price`, value: 'priceOut' },
            { text: 'Value', value: 'value' },
            { text: 'Copy Trade', value: 'actions' },
        ],
        iheaders: [
            { text: '', value: 'actions', class: 'mx-0 px-1 actions', cellClass: 'mx-0 px-1 actions' },
            { text: 'Pip', value: 'pip' },
            { text: 'Spot', value: 'spot' },
            { text: 'Symbol', value: 'value' },
            { text: 'Name', value: 'text' },
            { text: 'Market', value: 'market_display_name' },
            { text: 'Submarket', value: 'submarket_display_name' },
        ],
        search: '',
        isearch: '',
        besttrades: [],
        type: 'line',
        requiredRules: [(value: any) => !!value || 'Requise.'],
    }),

    methods: {
        chartType() {
            return this.type;
        },
        closeTradeWins() {
            this.$emit('closetrades');
        },
        onResize(event) {
            this.sm = window.innerWidth < 950 ? true : false;
            this.maxViewCount = this.activeSymbols.length > 4 ? 4 : this.activeSymbols.length;
            this.height = window.innerHeight - (this.sm ? 142 : 150);
            this.width = window.innerWidth - 8 - (this.sm || this.height < 500 ? 4 : 250);
            this.maxViewCount = this.maxViewCount > 2 && (this.sm || this.height < 500) ? 2 : this.maxViewCount;
            if (this.sm) {
                this.changeViewCount(1);
            }
            if (window.innerWidth > window.innerHeight != this.landscape) {
                window.location.reload();
            }
        },
        changeViewCount(n: number) {
            this.startTime = Date.now();
            if (n > this.viewCount) {
                this.viewCount = n;
                this.activeChartId = 0;
                let count = n - 1;
                let i = 1;
                this.activeChart[0] = this.activeChart[this.activeChartId];
                for (let index = 0; index < this.activeSymbols.length && count > 0 && i < 4; index++) {
                    if (this.activeChart[0].symbol != this.activeSymbols[index].id) {
                        this.activeChart[i] = {
                            tf: 60,
                            tfid: this.tfids[60],
                            intId: this.ids[this.activeSymbols[index].id],
                            symbol: this.activeSymbols[index].id,
                            symbolName: this.activeSymbols[index].text,
                            timer: 0,
                            lastUpdate: 0,
                            updated: false,
                        };
                        const symbol = this.activeChart[i].symbol;
                        const tf = this.activeChart[i].tf;
                        const intId = this.activeChart[i].intId;
                        const tfid = this.activeChart[i].tfid;
                        this.fetchChartDatas(i, 200, 0).then((data: any) => {
                            this.datas[intId][tfid].set('chart.data', data.data);

                            if (!(this.datas[intId][tfid].get('onchart').length > 1)) {
                                this.loadInds(symbol, tf);
                            }

                            //(this.$refs[`chart${data.id}`] as any).resetChart();
                        });

                        i += 1;
                        count -= 1;
                    }
                }
            } else {
                this.viewCount = n;
                this.activeChartId = this.activeChartId > this.viewCount - 1 ? this.viewCount - 1 : this.activeChartId;
            }
        },
        addSymbol(item: any) {
            const i = this.symbols.indexOf(item);
            if (!(this.symbols[i].value in this.ids)) {
                let timeframe = '1m';
                if (this.subMins.indexOf(this.symbols[i].value) != -1) {
                    timeframe = '1s';
                }
                this.datas.push(mkData());
                this.activeSymbols.push({
                    text: this.symbols[i].text,
                    id: this.symbols[i].value,
                    on: true,
                    lastUpdate: 0,
                });
                this.dataRetrieved = false;
                this.symbole('sym', this.symbols[i].value, this.symbols[i].text, this.activeSymbols.length - 1);
                this.ids[this.symbols[i].value] = this.activeSymbols.length - 1;
                // Tiingo binds the ticker set at subscribe time, so re-arm the
                // feed with the whole watchlist rather than adding one stream.
                if (liveFeed != undefined) {
                    liveFeed.setTickers(this.activeSymbols.map((el: any) => el.id));
                }
                this.storeAll();
            } else {
                this.symbole('sym', this.symbols[i].value, this.symbols[i].text, this.ids[this.symbols[i].value]);
            }
            this.maxViewCount = this.activeSymbols.length > 4 ? 4 : this.activeSymbols.length;
            this.maxViewCount = this.maxViewCount > 2 && (this.sm || this.height < 500) ? 2 : this.maxViewCount;
        },
        setLastUpdate(sym: string) {
            this.activeSymbols[this.ids[sym]].lastUpdate = Date.now();
        },
        isUpdated(sym: string) {
            if (!this.activeSymbols[this.ids[sym]].lastUpdate) {
                return false;
            }
            return Date.now() - this.activeSymbols[this.ids[sym]].lastUpdate > 15000 ? false : true;
        },
        removeSymbole(id: number, isCurrent: boolean) {
            this.removeInds(this.activeSymbols[id].id);
            if (isCurrent) {
                this.activeSymbols.splice(id, 1);
                this.datas.splice(id, 1);
                const swapId = this.activeSymbols.length - 1;

                this.symbole('rm', this.activeSymbols[swapId].id, this.activeSymbols[swapId].text, swapId);
            } else {
                this.activeSymbols.splice(id, 1);
                this.datas.splice(id, 1);
                if (id < this.activeChart[this.activeChartId].intId) {
                    this.activeChart[this.activeChartId].intId -= 1;
                }
                this.symbole(
                    'sym',
                    this.activeChart[this.activeChartId].symbol,
                    this.activeChart[this.activeChartId].symbolName,
                    this.activeChart[this.activeChartId].intId
                );
            }
            this.ids = {};
            for (let i = 0; i < this.activeSymbols.length; i++) {
                this.ids[this.activeSymbols[i].id] = i;
            }
            this.storeAll();
            this.maxViewCount = this.activeSymbols.length > 4 ? 4 : this.activeSymbols.length;
            this.maxViewCount = this.maxViewCount > 2 && (this.sm || this.height < 500) ? 2 : this.maxViewCount;
        },
        storeAll() {
            window.localStorage.setItem('on', 'true');
            window.localStorage.setItem('ids', JSON.stringify(this.ids));
            window.localStorage.setItem('prices', JSON.stringify(this.prices));
            window.localStorage.setItem('activeSymbols_v2', JSON.stringify(this.activeSymbols));
            window.localStorage.setItem('activeCharts', JSON.stringify(this.activeChart));
            window.localStorage.setItem('viewCounts', JSON.stringify(this.viewCount));
            window.localStorage.setItem('activeSymbol', JSON.stringify(this.activeChart[this.activeChartId].symbol));
            window.localStorage.setItem(
                'activeSymbolName',
                JSON.stringify(this.activeChart[this.activeChartId].symbolName)
            );
            window.localStorage.setItem('activeInternalId', JSON.stringify(this.activeChart[this.activeChartId].intId));
        },
        store() {
            window.localStorage.setItem('activeSymbol', JSON.stringify(this.activeChart[this.activeChartId].symbol));
            window.localStorage.setItem(
                'activeSymbolName',
                JSON.stringify(this.activeChart[this.activeChartId].symbolName)
            );
            window.localStorage.setItem('activeInternalId', JSON.stringify(this.activeChart[this.activeChartId].intId));
        },
        fetchMoreData(chartId: number) {
            if (!this.addData && !this.reset && this.dataRetrieved) {
                this.addData = true;
                const intId = this.activeChart[chartId].intId;
                const tfid = this.activeChart[chartId].tfid;

                this.fetchChartDatas(chartId, 500, Number(this.datas[intId][tfid].get('chart.data')[0][1][0])).then(
                    (res: any) => {
                        if (res != 'error') {
                            this.datas[intId][tfid].merge('chart.data', res.data);
                            this.addData = false;
                        } else {
                            this.fetchMoreData(chartId);
                        }
                    }
                );
            }
        },
        // Builds the symbol picker from the configured Tiingo tickers. The old
        // build read a static Deriv dump (Scripts/Actives.js) every time an
        // active_symbols message arrived; Tiingo sends no such message.
        populateSymbols() {
            inst.symbols = [];
            configuredTickers().forEach((ticker: string) => {
                const label = String(ticker).toUpperCase();
                inst.symbols.push({
                    text: label,
                    value: ticker,
                    market_display_name: 'Crypto',
                    symbol_type: 'crypto',
                    submarket_display_name: 'Crypto',
                    pip: 0.01,
                    spot: 0,
                });
                inst.symbolsNames[ticker] = label;
            });
        },
        async reinitConnexion() {
            console.log('reinit connexion');
            if (this.closing) {
                return;
            }
            this.dataRetrieved = false;
            this.stopWatch = true;
            const cId = this.activeChartId;
            const iId = this.activeChart[cId].intId;
            const tid = this.activeChart[cId].tfid;
            const sym = this.activeChart[cId].symbol;
            this.fetchChartDatas(cId, 200, 0).then((res: any) => {
                if (res != 'error') {
                    this.lastUpdate = Date.now();
                    this.datas[iId][tid].set('chart.data', res.data);

                    //if (!(this.datas[this.activeChart[this.activeChartId].intId][this.activeChart[this.activeChartId].tfid].get('onchart').length > 1)) {
                    this.loadCInds(sym, this.activeChart[res.id].tf);
                    //}

                    this.dataRetrieved = true;
                    this.populateSymbols();

                    const tickers = inst.activeSymbols.map((el: any) => el.id);
                    if (liveFeed == undefined) {
                        liveFeed = createLiveFeed({
                            tickers: tickers,
                            granularities: timeFrames.map((el) => el.value),
                            onOhlc: function (data: any) {
                                inst.handleFeedMessage(data);
                            },
                            onFatal: function (err: any) {
                                // A rejected token never recovers, so surface it
                                // rather than retrying forever.
                                console.error('[tiingo]', err.message);
                                inst.notificationText = err.message;
                            },
                        });
                        liveFeed.start();
                    } else {
                        liveFeed.setTickers(tickers);
                    }
                }
                this.stopWatch = false;
            });
        },
        // Receives each aggregated candle update from the Tiingo tick stream, in
        // the same shape the old Deriv 'ohlc' message had.
        handleFeedMessage(data: any) {
                        if (data['msg_type'] == 'ohlc') {
                            const symbol = data['ohlc']['symbol'];
                            const granularity = data['ohlc']['granularity'];
                            if (symbol in inst.ids) {
                                inst.setLastUpdate(symbol);
                                inst.prices[`${inst.ids[symbol]}`] = data['ohlc']['close'];
                                const payload = [
                                    data['ohlc']['open_time'] * 1000,
                                    Number(data['ohlc']['open']),
                                    Number(data['ohlc']['high']),
                                    Number(data['ohlc']['low']),
                                    Number(data['ohlc']['close']),
                                    0,
                                ];

                                if (symbol == inst.activeChart[inst.activeChartId].symbol && inst.dataRetrieved) {
                                    if (granularity == inst.activeChart[inst.activeChartId].tf) {
                                        inst.currentPrice = data['ohlc']['close'];
                                        inst.lastUpdate = Date.now();
                                    }
                                }

                                let found = false;
                                for (let index = 0; index < inst.viewCount && !found; index++) {
                                    if (
                                        inst.activeChart[index].symbol == symbol &&
                                        inst.activeChart[index].tf == granularity
                                    ) {
                                        found = true;
                                        const intId = inst.activeChart[index].intId;
                                        const tfid = inst.activeChart[index].tfid;
                                        if (!inst.datas[intId][tfid]) {
                                            return;
                                        }
                                        if (!inst.datas[intId][tfid].get('chart.data')[0]) {
                                            return;
                                        }
                                        if (!(inst.datas[intId][tfid].get('chart.data')[0].length > 0)) {
                                            return;
                                        }
                                        try {
                                            inst.activeChart[index].lastUpdate = Date.now();

                                            const newCandle = inst.$refs[`chart${index}`].data.update({
                                                candle: payload,
                                                //tf: granularity * 1000,
                                            });

                                            inst.datas[intId][tfid].merge('onchart.Trades.settings', {
                                                currentPrice: data['ohlc']['close'],
                                            });
                                            if (newCandle && inst.autoScroll) {
                                                inst.scrollToLast(index);
                                                //(inst.$refs[`chart${index}`] as any).resetChart();
                                            }
                                        } catch (error) {
                                            console.log(error);
                                            inst.activeChart[index].updated = false;

                                            //inst.datas[inst.activeChart[index].intId][inst.activeChart[index].tfid].tv.resetChart();
                                            /* let newData = new DataCube(JSON.parse(dataTemplate(inst.activeChart[index].tf)), {
                                                auto_scroll: false,
                                                scripts: true,
                                                script_depth: 0,
                                            }); */
                                            //inst.datas[inst.activeChart[index].intId][inst.activeChart[index].tfid] = newData;
                                            (inst.$refs[`chart${index}`] as any).resetChart();
                                            inst.datas[intId][tfid].tv = inst.$refs[`chart${index}`] as any;

                                            inst.fetchChartDatas(index, 200, 0).then((res: any) => {
                                                inst.datas[intId][tfid].set('chart.data', res.data);
                                                (inst.$refs[`chart${index}`] as any).toolbar = true;
                                                inst.$set(inst.datas[intId][tfid]['agg'], 'data_changed', true);
                                            });
                                        }
                                    }
                                }
                                if (!found) {
                                    if (!inst.datas[inst.ids[symbol]][inst.tfids[granularity]]) {
                                        return;
                                    }
                                    if (!inst.datas[inst.ids[symbol]][inst.tfids[granularity]].get('chart.data')[0]) {
                                        return;
                                    }
                                    if (
                                        !(
                                            inst.datas[inst.ids[symbol]][inst.tfids[granularity]].get('chart.data')[0]
                                                .length > 0
                                        )
                                    ) {
                                        return;
                                    }
                                    try {
                                        inst.datas[inst.ids[symbol]][inst.tfids[granularity]].update({
                                            candle: payload,
                                            //tf: granularity * 1000,
                                        });
                                    } catch (error) {
                                        //inst.datas[inst.ids[symbol]][inst.tfids[granularity]].tv
                                    }
                                }
                            }
                        }
        },
        watchUpdate(count: number) {
            this.now = Date.now();
            this.marketClosed = !this.isUpdated(this.activeChart[this.activeChartId].symbol);
            this.deltaTime = this.now - this.lastUpdate;
            for (let index = 0; index < this.activeChart.length; index++) {
                this.activeChart[index].updated = Date.now() - this.activeChart[index].lastUpdate < 10000;
            }
            if (!this.closing) {
                setTimeout(() => {
                    if (count % REFRESH_TICKS == 0 && !this.stopWatch) {
                        // Tiingo sends its own heartbeats, so no client-side keepalive.
                        for (let index = 0; index < this.viewCount; index++) {
                            if (
                                Date.now() % 3 == 0 &&
                                this.activeChart[index].updated &&
                                this.activeChart[index].symbol in this.copytrade &&
                                this.solde > this.value
                            ) {
                                this.takePos(
                                    index,
                                    this.activeChart[index].symbol,
                                    Date.now() % 2 == 0 ? 'sell' : 'buy',
                                    this.value,
                                    this.durations[Date.now() % 5].value
                                );
                            }
                            const intId = this.activeChart[index].intId;
                            const tfid = this.activeChart[index].tfid;
                            const symbol = this.activeChart[index].symbol;
                            this.fetchChartDatas(index, 50, 0).then((res: any) => {
                                // Can resolve to 'error' now that a request may be
                                // refused by the hourly budget, not just the network.
                                if (res != 'error' && res.data) {
                                    this.datas[intId][tfid].merge('chart.data', res.data);
                                }
                            });
                        }
                    }
                    this.watchUpdate(count + 1);
                }, 1000);
            }
        },
        async counter() {
            inst.tkey += 1;
            setTimeout(() => {
                for (let t = 0; t < this.viewCount; t++) {
                    this.activeChart[t].timer -= 1000;
                    if (this.activeChart[t].timer < 0) {
                        this.activeChart[t].timer = 0;
                    }
                    if (this.activeChart[t].updated) {
                        this.datas[this.activeChart[t].intId][this.activeChart[t].tfid].merge(
                            'onchart.Trades.settings',
                            { duration: this.activeChart[t].timer }
                        );
                    }
                }
                //  this.datas[this.activeChart[this.activeChartId].intId][this.activeChart[this.activeChartId].tfid].merge('onchart.Trades.settings', { duration: this.activeChart[this.activeChartId].timer });
                if (!this.closing) {
                    this.counter();
                }
            }, 1000);
        },
        rangeChanged(id: number) {
            const range = (this.$refs[`chart${id}`] as any).getRange();
            if (range[0] && range[1]) {
                if (
                    range[0] <
                        this.datas[this.activeChart[id].intId][this.activeChart[id].tfid].data.chart.data[0][0] &&
                    this.activeChart[id].updated
                ) {
                    this.fetchMoreData(id);
                }
            }
        },
        changeTf(tf: number) {
            this.activeChart[this.activeChartId].tf = tf;
            this.activeChart[this.activeChartId].tfid = this.tfids[tf];

            this.symbole(
                'tf',
                this.activeChart[this.activeChartId].symbol,
                this.activeChart[this.activeChartId].symbolName,
                this.activeChart[this.activeChartId].intId
            );
        },
        async symbole(arg: string, id: string, name: string, activeInternalId: number) {
            this.tools = false;
            if (activeInternalId != this.activeChart[this.activeChartId].intId || arg == 'tf' || arg == 'rm') {
                let found = false;

                if (arg == 'sym') {
                    for (let index = 0; index < this.viewCount && !found; index++) {
                        if (this.activeChart[index].symbol == id) {
                            found = true;
                            this.activeChartId = index;
                        }
                    }
                }
                const chartId = this.activeChartId;
                if (!found) {
                    (this.$refs[`chart${this.activeChartId}`] as any).resetChart();

                    this.reset = true;
                    this.activeChart[chartId].symbol = id;
                    this.activeChart[chartId].intId = activeInternalId;
                    this.activeChart[chartId].symbolName = name;
                    this.activeChart[chartId].timer = 5000;
                    //this.tf = this.tf; ????????????
                    this.lastPos = 'query';
                    this.store();
                    this.id = this.activeChart[chartId].symbol;
                    if (
                        this.datas[this.activeChart[chartId].intId][this.activeChart[chartId].tfid].data.chart.data
                            .length < 100
                    ) {
                        this.startTime = Date.now();
                        this.dataRetrieved = false;
                        this.activeChart[chartId].updated = false;
                    }
                    const intId = this.activeChart[chartId].intId;
                    const tfid = this.activeChart[chartId].tfid;
                    const tf = this.activeChart[chartId].tf;
                    const symbol = this.activeChart[chartId].symbol;

                    this.fetchChartDatas(chartId, 500, 0).then((res: any) => {
                        if (res != 'error' && res.symbole == this.activeChart[chartId].symbol) {
                            this.datas[intId][tfid].set('chart.data', res.data);

                            if (!(this.datas[intId][tfid].get('.').length > 2)) {
                                this.loadInds(symbol, tf);
                            }
                            (this.$refs[`chart${chartId}`] as any).resetChart();
                            let d = (this.$refs[`chart${this.activeChartId}`] as any)['data']['data']['chart'];
                            let chart = window.localStorage.getItem('chartType') || 'Candles';
                            this.$set(d, 'type', chart);
                            this.reset = false;
                            this.dataRetrieved = true;
                            // console.log('reseted');
                        }
                    });
                }
            }
        },
        upload() {
            return new Promise((resolve, reject) => {
                const data = new FormData();
                data.append(
                    'file',
                    new Blob([
                        JSON.stringify(
                            this.datas[this.activeChart[this.activeChartId].intId][
                                this.activeChart[this.activeChartId].tfid
                            ].get('chart.data')[0]
                        ),
                    ]),
                    'datas'
                );
                const config = {
                    headers: { 'Content-Type': 'multipart/form-data' },
                };

                resolve('done');
            });
        },
        async fetchDatas(count: number, end: number): Promise<{ symbole: string; data: any[] } | String> {
            //{symbole: symbole_id, data: [eohlc]}
            return new Promise((resolve, reject) => {
                const data = {
                    symbole: this.activeChart[this.activeChartId].symbol,
                    tf: this.activeChart[this.activeChartId].tf,
                    count: count,
                    end: end,
                    userid: id,
                    token: token,
                };
                this.apiInterface[this.demo ? 'demo' : 'core']
                    .history({ body: { data: JSON.stringify(data) } })

                    .then((_res) => {
                        const res = getNonRefObj(_res);

                        if (res.status == 200) {
                            resolve(res.data);
                        } else {
                            resolve('error');
                        }
                    })
                    .catch((err: any) => {
                        if (err.message == 'timeout of 1000ms exceeded') {
                            // console.log('timeout');
                        }
                        resolve('error');
                        this.snackbar = true;
                    });
            });
        },
        async fetchChartDatas(
            chartId: number,
            count: number,
            end: number
        ): Promise<{ symbole: string; data: any[]; id: number } | String> {
            //{symbole: symbole_id, data: [eohlc]}
            return new Promise((resolve, reject) => {
                const data = {
                    symbole: this.activeChart[chartId].symbol,
                    tf: this.activeChart[chartId].tf,
                    count: count,
                    end: end,
                    userid: id,
                    token: token,
                };
                this.apiInterface[this.demo ? 'demo' : 'core']
                    .history({ body: { data: JSON.stringify(data) } })

                    .then((_res) => {
                        const res = getNonRefObj(_res);

                        if (res.status == 200) {
                            resolve({ ...res.data, id: chartId });
                        } else {
                            resolve('error');
                        }
                    })
                    .catch((err: any) => {
                        if (err.message == 'timeout of 1000ms exceeded') {
                            // console.log('timeout');
                        }
                        resolve('error');
                        this.snackbar = true;
                    });
            });
        },
        async fetchNewDatas(
            sym: string,
            id: number,
            count: number,
            end: number
        ): Promise<{ symbole: string; data: any[] } | String> {
            //{symbole: symbole_id, data: [eohlc]}
            return new Promise((resolve, reject) => {
                const data = {
                    symbole: sym,
                    tf: this.activeChart[this.activeChartId].tf,
                    count: count,
                    end: end,
                    userid: id,
                    token: token,
                };
                this.apiInterface[this.demo ? 'demo' : 'core']
                    .history({ body: { data: JSON.stringify(data) } })

                    .then((_res) => {
                        const res = getNonRefObj(_res);

                        if (res.status == 200) {
                            resolve({ ...res.data, id: id });
                        } else {
                            resolve('error');
                        }
                    })
                    .catch((err: any) => {
                        if (err.message == 'timeout of 1000ms exceeded') {
                            // console.log('timeout');
                        }
                        resolve('error');
                        this.snackbar = true;
                    });
            });
        },
        async ping(chartId: number) {
            return new Promise((resolve, reject) => {
                const intId = this.activeChart[chartId].intId;
                const tfid = this.activeChart[chartId].tfid;
                this.datas[this.activeChart[this.activeChartId].intId][this.activeChart[this.activeChartId].tfid].merge(
                    'onchart.Trades.settings',
                    { night: this.night }
                );
                this.datas[intId][tfid].merge('onchart.Trades.settings', { tradeType: this.tradeType });
                let activeSyms = [] as any[];
                for (let t = 0; t < this.viewCount; t++) {
                    if (t != this.activeChartId) {
                        activeSyms.push(this.activeChart[t].symbol);
                    }
                }
                const data = {
                    symbole: this.activeChart[chartId].symbol,
                    userid: id,
                    token: token,
                    activesymboles: activeSyms,
                };
                // console.log('ping', data);
                this.apiInterface[this.demo ? 'demo' : 'core']
                    .ping({ body: { data: JSON.stringify(data) } })

                    .then((_res) => {
                        const res = getNonRefObj(_res);

                        // console.log('ping res, ', res);
                        if (res.status == 200) {
                            let closed = true;
                            this.datas[intId][tfid].merge('onchart.Trades.settings', {
                                spread: res.data.spread,
                                mult: res.data.keyid,
                            });
                            if (res.data.lastPosition != 'empty') {
                                closed = false;
                                // // console.log('in', this.timer, this.lastPos);

                                if (
                                    res.data.lastPosition.type == 'pending-buy' ||
                                    res.data.lastPosition.type == 'pending-sell'
                                ) {
                                    this.lastPos = res.data.lastPosition.type;
                                    this.datas[intId][tfid].merge('onchart.Swap.settings', {
                                        pending: true,
                                        pending_type: res.data.lastPosition.type,
                                        pending_price: res.data.lastPosition.price,
                                        pending_value: res.data.lastPosition.value,
                                    });
                                    this.activeChart[chartId].timer = 0;
                                } else {
                                    this.datas[intId][tfid].merge('onchart.Swap.settings', {
                                        pending: false,
                                        pending_type: '',
                                        pending_price: 0,
                                        pending_value: 0,
                                    });

                                    if (this.lastPos == 'query' || res.data.lastPosition.left > 11000) {
                                        this.activeChart[chartId].timer = res.data.lastPosition.left;
                                    }
                                    this.lastPos = res.data.lastPosition.type;
                                    this.lastPosValue = res.data.lastPosition.value;
                                    this.lastPosPrice = res.data.lastPosition.price;
                                    this.lastPosSpread = res.data.lastPosition.spread;
                                    this.lastPosTS = res.data.lastPosition.timestamp;
                                    this.lastPosDuration = res.data.lastPosition.duration;
                                    this.activeChart[chartId].timer =
                                        res.data.lastPosition.type != 'close' && this.activeChart[chartId].timer > 11000
                                            ? res.data.lastPosition.left
                                            : this.activeChart[chartId].timer;
                                }
                                this.datas[intId][tfid].merge('onchart.Trades.settings', { pType: this.lastPos });
                            }

                            if (res.data.data != 'empty') {
                                const positionDatas = getNonRefObj(res.data.data);
                                this.datas[intId][tfid].merge('onchart.Trades.data', positionDatas);
                            } else if (closed) {
                                this.lastPos = 'close';
                                this.activeChart[chartId].timer = 0;
                            }
                            if (res.data.tradeWins != 'empty') {
                                this.besttrades = res.data.tradeWins;
                            }
                            if (res.data.otherPositions != 'empty') {
                                for (let i = 0; i < res.data.otherPositions.length; i++) {
                                    const ts = res.data.otherPositions[i].timestamp;
                                    const d = res.data.otherPositions[i].duration;
                                    const sym = res.data.otherPositions[i].symbol;
                                    const type = res.data.otherPositions[i].type;
                                    const value = res.data.otherPositions[i].value;
                                    const price = res.data.otherPositions[i].price;
                                    const pSpread = res.data.otherPositions[i].spread;
                                    const left = res.data.otherPositions[i].left;
                                    this.winLosses[`${inst.ids[sym]}`] = this.winLoss(
                                        this.prices[`${inst.ids[sym]}`],
                                        type,
                                        price,
                                        value,
                                        pSpread
                                    );
                                    /*  for (let t = 0; t < this.viewCount; t++) {
                                            if (t != this.activeChartId && this.activeChart[t].symbol == sym && this.activeChart[t].timer < 5000) {
                                                this.pingSym(t);
                                            }
                                        } */

                                    this.poses[`${inst.ids[sym]}`] = {
                                        symbol: sym,
                                        type: type,
                                        value: value,
                                        price: price,
                                        left: left,
                                        duration: d,
                                        timestamp: ts,
                                    };
                                }
                            }

                            for (let t = 0; t < this.viewCount && t < 4; t++) {
                                const sym = this.activeChart[t].symbol;
                                const tid = this.activeChart[t].tfid;
                                const iid = this.activeChart[t].intId;
                                if (res.data.symLastPositions != 'empty') {
                                    if (t != chartId && sym in res.data.symLastPositions) {
                                        if (
                                            res.data.symLastPositions[sym].type == 'pending-buy' ||
                                            res.data.symLastPositions[sym].type == 'pending-sell'
                                        ) {
                                            this.datas[iid][tid].merge('onchart.Swap.settings', {
                                                pending: true,
                                                pending_type: res.data.symLastPositions[sym].type,
                                                pending_price: res.data.symLastPositions[sym].price,
                                                pending_value: res.data.symLastPositions[sym].value,
                                            });
                                            this.activeChart[t].timer = 0;
                                        } else {
                                            this.datas[iid][tid].merge('onchart.Swap.settings', {
                                                pending: false,
                                                pending_type: '',
                                                pending_price: 0,
                                                pending_value: 0,
                                            });
                                            this.activeChart[t].timer = res.data.symLastPositions[sym].left;
                                            const len = this.datas[iid][tid].get('onchart.Trades.data')[0].length;
                                            if (len != 0) {
                                                if (
                                                    res.data.symLastPositions[sym].type == 'close' &&
                                                    this.datas[iid][tid].get('onchart.Trades.data')[0][len - 1][1] != 3
                                                ) {
                                                    this.pingSym(t);
                                                }
                                            } else if (res.data.symLastPositions[sym] != 'empty') {
                                                this.pingSym(t);
                                            }
                                        }
                                    }
                                }
                                if (res.data.symSpreads && res.data.symSpreads != 'empty') {
                                    if (sym in res.data.symSpreads) {
                                        this.datas[iid][tid].merge('onchart.Trades.settings', {
                                            spread: res.data.symSpreads[sym],
                                        });
                                    }
                                }
                            }

                            if (res.data.lastHistory != 'empty') {
                                this.histories.push(res.data.lastHistory);
                            }

                            this.solde = res.data.solde;
                            this.$emit(this.demo ? 'demo' : 'solde', this.solde);
                            if (!this.closing) {
                                ///
                            } else {
                                resolve('done');
                            }
                        }
                        if (res.status == 401) {
                            this.notifyError = true;
                            this.notificationTitle = `Session expired`;
                            this.notificationText = `Please reconnect`;
                        } else {
                            resolve('error');
                        }
                    })
                    .catch((err: any) => {
                        // console.log('ping err', err);
                        if (err.message == 'timeout of 1000ms exceeded') {
                            // console.log('timeout');
                        }
                        this.snackbar = true;

                        resolve('error');
                    });
            });
        },
        async pingSym(chartid: number) {
            return new Promise((resolve, reject) => {
                const intId = this.activeChart[chartid].intId;
                const tfid = this.activeChart[chartid].tfid;
                const data = {
                    symbole: this.activeChart[chartid].symbol,
                    userid: id,
                    token: token,
                    activesymboles: [],
                };
                this.apiInterface[this.demo ? 'demo' : 'core']
                    .ping({ body: { data: JSON.stringify(data) } })

                    .then((_res) => {
                        const res = getNonRefObj(_res);

                        if (res.status == 200) {
                            if (res.data.data != 'empty') {
                                this.datas[intId][tfid].merge('onchart.Trades.data', res.data.data);
                            }
                            if (res.data.lastPosition != 'empty') {
                                // // console.log('in', this.timer, this.lastPos);
                                if (
                                    res.data.lastPosition.type == 'pending-buy' ||
                                    res.data.lastPosition.type == 'pending-sell'
                                ) {
                                    this.datas[intId][tfid].merge('onchart.Swap.settings', {
                                        pending: true,
                                        pending_type: res.data.lastPosition.type,
                                        pending_price: res.data.lastPosition.price,
                                        pending_value: res.data.lastPosition.value,
                                    });
                                    this.activeChart[chartid].timer = 0;
                                } else {
                                    this.datas[intId][tfid].merge('onchart.Swap.settings', {
                                        pending: false,
                                        pending_type: '',
                                        pending_price: 0,
                                        pending_value: 0,
                                    });
                                    this.activeChart[chartid].timer = res.data.lastPosition.left;
                                }
                            }
                            resolve('done');
                        } else {
                            resolve('error');
                        }
                    })
                    .catch((err: any) => {
                        const result = JSON.stringify(err);
                        const status = JSON.parse(result);
                        if (status.status == 401) {
                            this.notifyError = true;
                            this.notificationTitle = `Session expired`;
                            this.notificationText = `Please reconnect`;
                        } else {
                            if (err.message == 'timeout of 1000ms exceeded') {
                                // console.log('timeout');
                            }

                            resolve('error');
                        }
                    });
            });
        },
        takePos(
            chartid: number,
            sym: string,
            type: string,
            value: number,
            duration: number
        ): Promise<{ symbole: string; data: any[] } | String> {
            //{symbole: symbole_id, data: [eohlc]}
            if (this.pending) {
                return new Promise((resolve, reject) => {
                    this.pendingPosType = type;
                    resolve('done');
                });
            } else {
                this.lastPos = 'loading';
                this.activeChart[chartid].timer = duration;
                return new Promise((resolve, reject) => {
                    const data = {
                        symbole: sym,
                        type: type,
                        userid: id,
                        token: token,
                        value: value,
                        duration: duration,
                    };
                    this.apiInterface[this.demo ? 'demo' : 'core']
                        .takeposition({ body: { data: JSON.stringify(data) } })

                        .then((_res) => {
                            const res = getNonRefObj(_res);
                            if (res.status == 200) {
                                //this.datas[this.activeInternalId].merge('onchart.Trades.data', res.data.data);
                                if (this.activeChartId == chartid) {
                                    this.lastPos = type;
                                } else {
                                    this.lastPos = 'query';
                                }
                                resolve(res.data);
                            } else if (res.status == 201) {
                                this.lastPos = 'query';
                                this.activeChart[this.activeChartId].timer = 0;
                                resolve('error'); //Show notification
                            } else {
                                this.activeChart[chartid].timer = 0;
                                this.lastPos = 'query';
                                resolve('error');
                            }
                        })
                        .catch((err: any) => {
                            if (err.message == 'timeout of 1000ms exceeded') {
                                // console.log('timeout');
                            }
                            this.activeChart[chartid].timer = 0;
                            this.lastPos = 'query';
                            resolve('error');
                        });
                });
            }
        },
        confirmPending(ev: any, chartId: number) {
            if (this.pending && this.pendingPosType != '') {
                this.pendingPos.symbole = this.activeChart[chartId].symbol;
                this.pendingPos.symboleName = this.activeChart[chartId].symbolName;
                this.pendingPos.type = this.pendingPosType;
                this.pendingPos.duration = this.duration;
                this.pendingPos.price = this.toFixed(ev, 4);
                this.pendingPos.value = this.value;
                this.pendingOverlay = true;
                this.datas[this.activeChart[this.activeChartId].intId][this.activeChart[this.activeChartId].tfid].merge(
                    'onchart.Swap.settings',
                    { price: ev }
                );
            }
        },
        takePendingPos() {
            this.lastPos = 'loading';
            const chartId = this.activeChartId;
            this.activeChart[chartId].timer = 0;
            return new Promise((resolve, reject) => {
                const data = {
                    symbole: this.pendingPos.symbole,
                    type: this.pendingPos.type,
                    userid: id,
                    token: token,
                    price: this.pendingPos.price,
                    value: this.pendingPos.value,
                    duration: this.pendingPos.duration,
                };
                this.pendingPosType = '';
                this.pendingPos = {
                    symbole: '',
                    symboleName: '',
                    value: 0,
                    type: '',
                    price: 0,
                    duration: 60,
                };
                this.pendingOverlay = false;

                this.apiInterface[this.demo ? 'demo' : 'core']
                    .pendingposition({ body: { data: JSON.stringify(data) } })

                    .then((_res) => {
                        const res = getNonRefObj(_res);

                        if (res.status == 200) {
                            this.lastPos = 'query';
                            resolve(res.data);
                        } else if (res.status == 201) {
                            this.lastPos = 'query';
                            this.activeChart[chartId].timer = 0;

                            resolve('error'); //Show notification
                        } else {
                            this.activeChart[chartId].timer = 0;

                            this.lastPos = 'query';
                            resolve('error');
                        }
                    })
                    .catch((err: any) => {
                        if (err.message == 'timeout of 1000ms exceeded') {
                            // console.log('timeout');
                        }
                        this.activeChart[chartId].timer = 0;
                        this.lastPos = 'query';

                        resolve('error');
                    });
            });
        },
        closePos(sym: string): Promise<{ symbole: string; data: any[] } | String> {
            //{symbole: symbole_id, data: [eohlc]}
            const lastpos = this.lastPos;
            this.lastPos = 'loading';

            return new Promise((resolve, reject) => {
                let data;
                let url = '';
                if (lastpos == 'pending-buy' || lastpos == 'pending-sell') {
                    data = { symbole: sym, type: 'leave', userid: id, token: token };
                    url = `closepending`;
                } else {
                    data = {
                        symbole: sym,
                        type: 'leave',
                        userid: id,
                        token: token,
                        value: this.lastPosValue,
                        duration: this.lastPosDuration,
                        timestamp: this.lastPosTS,
                    };
                    url = `closeposition`;
                }

                this.apiInterface[this.demo ? 'demo' : 'core']
                    [`${url}`]({ body: { data: JSON.stringify(data) } })

                    .then((_res) => {
                        const res = getNonRefObj(_res);

                        if (res.status == 200) {
                            this.activeChart[this.activeChartId].timer = 0;
                            this.lastPos = 'close';
                            resolve(res.data);
                        } else if (res.status == 201) {
                            this.lastPos = 'query';
                            resolve('error'); //Show notification
                        } else {
                            this.lastPos = 'query';
                            resolve('error');
                        }
                    })
                    .catch((err: any) => {
                        if (err.message == 'timeout of 1000ms exceeded') {
                            // console.log('timeout');
                        }
                        this.lastPos = 'query';
                        resolve('error');
                    });
            });
        },
        closeOtherPos(
            sym: string,
            type: string,
            value: number,
            duration: number,
            timestamp: number
        ): Promise<{ symbole: string; data: any[] } | String> {
            //{symbole: symbole_id, data: [eohlc]}
            this.lastPos = 'loading';

            return new Promise((resolve, reject) => {
                //const data = { symbole: sym, type: 'leave', userid: id, token: token, value: value, duration: duration, timestamp: timestamp };
                let data;
                let url = '';
                if (type == 'pending-buy' || type == 'pending-sell') {
                    data = { symbole: sym, type: 'leave', userid: id, token: token };
                    url = `closepending`;
                } else {
                    data = {
                        symbole: sym,
                        type: 'leave',
                        userid: id,
                        token: token,
                        value: value,
                        duration: duration,
                        timestamp: timestamp,
                    };
                    url = `closeposition`;
                }
                this.apiInterface[this.demo ? 'demo' : 'core']
                    [`${url}`]({ body: { data: JSON.stringify(data) } })

                    .then((_res) => {
                        const res = getNonRefObj(_res);
                        if (res.status == 200) {
                            //this.datas[this.activeInternalId].merge('onchart.Trades.data', res.data.data);
                            //this.activeChart[this.activeChartId].timer = 0;
                            resolve(res.data);
                        } else if (res.status == 201) {
                            resolve('error'); //Show notification
                        } else {
                            resolve('error');
                        }
                    })
                    .catch((err: any) => {
                        if (err.message == 'timeout of 1000ms exceeded') {
                            // console.log('timeout');
                        }
                        resolve('error');
                    });
            });
        },
        addonchart(payload: any) {
            const data = Object.assign({}, payload);
            this.datas[this.activeChart[this.activeChartId].intId][this.activeChart[this.activeChartId].tfid].add(
                'onchart',
                data
            );
            this.saveInds(this.activeChart[this.activeChartId].symbol);
        },
        addoffchart(payload: any) {
            const data = Object.assign({}, payload);
            this.datas[this.activeChart[this.activeChartId].intId][this.activeChart[this.activeChartId].tfid].add(
                'offchart',
                data
            );
            this.saveInds(this.activeChart[this.activeChartId].symbol);
        },
        saveInds(symbol: string) {
            window.localStorage.removeItem(symbol);
            let ind_set =
                this.datas[this.activeChart[this.activeChartId].intId][this.activeChart[this.activeChartId].tfid].get(
                    'onchart'
                );
            let off_set =
                this.datas[this.activeChart[this.activeChartId].intId][this.activeChart[this.activeChartId].tfid].get(
                    'offchart'
                );
            let settings = [] as any[];
            ind_set.forEach((el) => {
                settings.push(parseSettings(el, 'onchart'));
            });
            off_set.forEach((el) => {
                settings.push(parseSettings(el, 'offchart'));
            });
            const set = JSON.stringify(settings);

            window.localStorage.setItem(symbol, set);
        },
        loadInds(symbol: string, tf: number) {
            let save = false;
            const defaultModelData = window.localStorage.getItem('defaultModel');
            const symbolModel = window.localStorage.getItem(symbol);
            if ((symbolModel != null || defaultModelData != null) && this.ids[symbol] != undefined) {
                let settings;
                if (symbolModel != null) {
                    settings = JSON.parse(String(window.localStorage.getItem(symbol)));
                } else if (defaultModelData != null) {
                    const data = JSON.parse(defaultModelData);
                    settings = JSON.parse(data['data']);
                    save = true;
                }

                settings.forEach((el) => {
                    if (el['set']['type'] != 'PerfectTrades' && el['set']['type'] != 'Swap') {
                        inst.datas[this.ids[symbol]][this.getTfId(tf)].add(el['side'], {
                            ...el['set'],
                            tf: tf * 1000,
                            script: { execOnRange: true, execInterval: 0 },
                            scripts: true,
                        });
                    }
                });
                inst.datas[this.ids[symbol]][inst.tfids[tf]].set('.data', []);
                if (save) {
                    this.saveInds(symbol);
                }
            }
        },
        loadCInds(symbol: string, tf: number) {
            let save = false;
            const defaultModelData = window.localStorage.getItem('defaultModel');
            const symbolModel = window.localStorage.getItem(symbol);
            if ((symbolModel != null || defaultModelData != null) && this.ids[symbol] != undefined) {
                inst.datas[this.ids[symbol]][inst.tfids[tf]].set('.data', []);
                (this.$refs[`chart${this.activeChartId}`] as any).resetChart();
                let settings;
                if (symbolModel != null) {
                    settings = JSON.parse(String(window.localStorage.getItem(symbol)));
                } else if (defaultModelData != null) {
                    const data = JSON.parse(defaultModelData);
                    settings = JSON.parse(data['data']);
                    save = true;
                }

                let swap = this.datas[this.ids[symbol]][this.getTfId(tf)].get('.');

                swap.forEach((el) => {
                    if (el.type != 'PerfectTrades' && el.type != 'Swap')
                        this.datas[this.ids[symbol]][this.getTfId(tf)].del(el.id);
                });

                if (settings) {
                    if (settings.length > 0) {
                        settings.forEach((el) => {
                            if (el['set']['type'] != 'PerfectTrades' && el['set']['type'] != 'Swap') {
                                this.datas[this.ids[symbol]][this.getTfId(tf)].add(el['side'], {
                                    ...el['set'],
                                    tf: tf * 1000,
                                    script: { execOnRange: true, execInterval: 0 },
                                    scripts: true,
                                });
                            }
                        });
                    }
                }
                (this.$refs[`chart${this.activeChartId}`] as any).resetChart();
                if (save) {
                    this.saveInds(symbol);
                }
            }
        },

        removeInds(symbol: string) {
            window.localStorage.removeItem(symbol);
        },
        getTfId(tf: number) {
            return Number(this.tfids[`${tf}`]);
        },
        getSymName(id: string) {
            let result = '';
            if (id in this.symbolsNames) {
                result = this.symbolsNames[id];
            }
            return result;
        },
        winLoss(currentPrice: number, posType: string, posPrice: number, posValue: number, posSpread: number) {
            if (!posType) {
                return { win: -1, gain: '' };
            }
            if (posType == 'buy' || posType == 'sell') {
                if ((posType == 'buy' && currentPrice > posPrice) || (posType == 'sell' && currentPrice < posPrice)) {
                    return { win: 1, gain: `+ ${(posValue * 0.85).toFixed(2)} €` };
                } else {
                    return { win: 0, gain: `- ${posValue.toFixed(2)} €` };
                }
            } else if (posType == 'in') {
                if (posPrice + posSpread * inMult > currentPrice && posPrice - posSpread * inMult < currentPrice) {
                    return { win: 1, gain: `+ ${(posValue * 0.85).toFixed(2)} €` };
                } else {
                    return { win: 0, gain: `- ${posValue.toFixed(2)} €` };
                }
            } else if (posType == 'out') {
                if (!(posPrice + posSpread * outMult > currentPrice && posPrice - posSpread * outMult < currentPrice)) {
                    return { win: 1, gain: `+ ${(posValue * 0.85).toFixed(2)} €` };
                } else {
                    return { win: 0, gain: `- ${posValue.toFixed(2)} €` };
                }
            } else {
                return { win: -1, gain: '' };
            }
        },
        addCpyTrade(item: any) {
            if (item.uid == 'delete') {
                delete this.copytrade[item.symbol];
            } else if (!(item.symbol in this.copytrade)) {
                this.copytrade[item.symbol] = item.uid;
            } else if (this.copytrade[item.symbol] != item.uid) {
                this.copytrade[item.symbol] = item.uid;
            } else {
                delete this.copytrade[item.symbol];
            }
        },
        getIcon(type: string) {
            if (type == 'buy') return 'mdi-trending-up';
            if (type == 'sell') return 'mdi-trending-down';
            if (type == 'in') return 'mdi-arrow-collapse-vertical';
            if (type == 'out') return 'mdi-arrow-split-horizontal';
            return 'mdi-weather-night';
        },
        testInd() {
            //this.datas.merge('onchart.EMA0.settings', { length: 20 }); //change settings ok
            /*                                                           //add ok
            const settings = {
                name: `EMA $length`,
                type: 'EMA',
                data: [],
                settings: {
                    color: '#890c00',
                    length: 50,
                    applyto: `hl2`,
                },
            };
            this.datas[this.activeInternalId].add('onchart', settings);*/
            //save ok
            /* // console.log(this.datas[this.activeInternalId].get('onchart'));
            let ind_set = this.datas[this.activeInternalId].get('onchart');
            let settings = [] as any[];
            ind_set.forEach((el) => {
                settings.push(parseSettings(el));
            });
            const set = JSON.stringify(settings);
            // console.log('saved = ', set);
            window.localStorage.setItem('set', set); */
            //this.saveInds('test');
            //// console.log(this.datas[this.activeInternalId][this.currentTfId].get('chart'));
            /*  console.log(
                this.datas[this.ids[this.activeChart[this.activeChartId].symbol]][
                    this.activeChart[this.activeChartId].tfid
                ]
            ); */
        },
        testInd2() {
            //const settings = JSON.parse(String(window.localStorage.getItem('set'))); //reload saved ok
            //console.log('loaded = ', this.datas[this.activeInternalId].get('tools'));
            //console.log('loaded = ', this.datas[this.activeInternalId].get('.'));
            /*  settings.forEach((el) => {
                this.datas[this.activeInternalId].add('onchart', el);
            });  */
            //this.datas[this.activeInternalId].merge('onchart', ...settings);????
            //console.log('datas[0]', this.datas[0].get('chart.data')[0]);
            //this.loadInds(this.activeSymbol);
            //this.takePos(this.activeSymbol, 'close', this.value, this.duration);
            //this.datas[this.activeInternalId][this.currentTfId].merge('.', { tf: 300000 });
            //this.datas[this.activeInternalId][this.currentTfId].merge('chart', { tf: 300000 });
            //this.loadInds(this.activeSymbol, this.tf);
            //(this.$refs.chart as any).resetChart();
            //this.datas[this.ids[this.activeSymbol]][this.currentTfId].tv.$refs.chart.update_last_values();
            //this.datas[this.ids[this.activeSymbol]][this.currentTfId].merge('.', { tf: this.tf * 1000 });
            // console.log(this.datas[this.activeChart[this.activeChartId].intId][this.activeChart[this.activeChartId].tfid]);
            // console.log(this.$refs[`chart${this.activeChartId}`] as any);
            /* let newData = new DataCube(JSON.parse(dataTemplate(inst.activeChart[this.activeChartId].tf)), {
                auto_scroll: false,
                scripts: true,
                script_depth: 0,
            }); */
            //inst.datas[inst.activeChart[this.activeChartId].intId][inst.activeChart[this.activeChartId].tfid] = newData;
            //inst.$refs[`chart${this.activeChartId}`].resetChart();
            //inst.datas[inst.activeChart[this.activeChartId].intId][inst.activeChart[this.activeChartId].tfid] = new DataCube(inst.$refs[`chart${this.activeChartId}`]['decubed']);
            //inst.datas[inst.activeChart[this.activeChartId].intId][inst.activeChart[this.activeChartId].tfid].tv = inst.$refs[`chart${this.activeChartId}`] as any;
            console.log(
                this.datas[this.activeChart[this.activeChartId].intId][this.activeChart[this.activeChartId].tfid].get(
                    'onchart.Trades.data'
                )[0][0]
            );
        },
        scrollToLast(id: number) {
            if (this.autoScroll && this.dataRetrieved) {
                const len =
                    this.datas[Number(inst.ids[this.activeChart[id].symbol])][inst.tfids[this.activeChart[id].tf]].data
                        .chart.data.length;
                (this.$refs[`chart${id}`] as any).goto(len + 4.5);
            }
        },
        toFixed(val: number, fract: number) {
            return Number(Number(val).toFixed(fract));
        },
        on_button_click(event, id) {
            if (event.button === 'display') {
                if (event.overlay == 'Swap_0') {
                    let d = (this.$refs[`chart${id}`] as any)['data']['data']['chart'];
                    if (d.type == 'Candles') {
                        this.$set(d, 'type', 'XOhlcBars');
                        window.localStorage.setItem('chartType', 'XOhlcBars');
                    } else {
                        this.$set(d, 'type', 'Candles');
                        window.localStorage.setItem('chartType', 'Candles');
                    }
                } else {
                    let d = (this.$refs[`chart${id}`] as any)['data']['data'][event.type][event.dataIndex];
                    if (d) {
                        if (!('display' in d.settings)) {
                            this.$set(d.settings, 'display', true);
                        }
                        this.$set(d.settings, 'display', !d.settings.display);
                    }
                }
            }
        },
        onFocus(ev: any) {
            // console.log('Focused');
            this.focused = true;
            if (Date.now() - this.blurTime > 300000) {
                window.location.reload();
            } else if (Date.now() - this.blurTime > 30000) {
                for (let i = 0; i < this.viewCount; i++) {
                    const intId = this.activeChart[i].intId;
                    const tfid = this.activeChart[i].tfid;
                    this.fetchChartDatas(i, 200, 0).then((data: any) => {
                        this.datas[intId][tfid].merge('chart.data', data.data);
                    });
                }
            }
        },
        onBlur(ev: any) {
            // console.log('Lost focus');
            this.blurTime = Date.now();
            this.focused = false;
        },
    },
    components: {
        TradingVue,
        iOvl,
    },
});
